import * as React from "react";
var ViewAllButton = function (props) { return (React.createElement("button", { className: ["view-all-button", "clickable", !props.visibility ? "hidden" : ""].join(" "), onClick: function () { return props.onViewAllButtonClick(); }, type: "button" }, props.buttonText)); };
export default ViewAllButton;
